(function () {
  var hash = window.location.hash;
  if (!/^#discord_(attempt|denied|error)=/.test(hash)) return;
  // This classic blocking script runs before the application module and any
  // third-party scripts. Completion proof is removed from the address bar
  // first and kept only in a one-use memory closure, never browser storage.
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
  var fields = new URLSearchParams(hash.slice(1));
  var value = fields.get('discord_denied') === '1' ? { denied: true } : null;
  var attemptId = fields.get('discord_attempt'), completionProof = fields.get('discord_proof');
  if (/^[a-zA-Z0-9_-]{43}$/.test(attemptId || '') && /^[a-zA-Z0-9_-]{43}$/.test(completionProof || '')) {
    value = { attemptId: attemptId, completionProof: completionProof };
  }
  Object.defineProperty(window, '__takeDiscordCallback', { configurable: true, value: function () {
    var result = value; value = null; delete window.__takeDiscordCallback; return result;
  } });
})();
